export default __webpack_public_path__ + "_/shared_modules/base-layout/img/pf_sprite_home-6c803428e7b7263d4efe67b2a9f9b4c8.png";